import React from 'react';
import { SearchState } from './reducers/searchReducer';
import { xhrClient } from '../../services/xhrClient';
import { SearchAction } from './reducers/SearchActions';

const useSearchResults = (
    { courseTypes, searchTerms, subTopics }: SearchState,
    resultsApiPath: string,
    dispatch: React.Dispatch<SearchAction>,
) => {
    React.useEffect(
        function fetchResults() {
            const { cancel, isCancel, promise } = xhrClient.getProductSearchResult(
                resultsApiPath,
                searchTerms,
                courseTypes,
                subTopics,
            );

            (async function getProductTiles() {
                try {
                    dispatch({ type: 'queryInit' });
                    const { data } = await promise;
                    dispatch({ type: 'querySuccess', payload: data.productTiles });
                } catch (thrown) {
                    if (!isCancel(thrown)) {
                        console.error(thrown);
                        dispatch({ type: 'queryFailure' });
                    }
                }
            })();

            return function cleanup() {
                cancel(
                    `Canceled product search for searchTerms: '${searchTerms}', courseTypes.size: ${courseTypes.size}, subTopics.size: ${subTopics.size}`,
                );
            };
        },
        [searchTerms, courseTypes, subTopics],
    );
};

export { useSearchResults };
